import React, { useState } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { SlidebarHeader, SliderButton } from "./style";

export const Sliderbar = ({ arrayComponents }) => {
  const [currentIndex, setCurrent] = useState(0);
  const backButton = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide
      ? arrayComponents.length - 1
      : currentIndex - 1;
    setCurrent(newIndex);
  };

  const nextImg = () => {
    const isLastSlide = currentIndex === arrayComponents.length - 1;
    const nextIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrent(nextIndex);
  };

  return (
    <SlidebarHeader>
      {arrayComponents[currentIndex].name()}
      <SliderButton>
        <AiOutlineArrowLeft
          size={25}
          color="gray"
          className="arrowback"
          onClick={backButton}
        />
        <AiOutlineArrowRight size={25} color="gray" onClick={nextImg} />
      </SliderButton>
    </SlidebarHeader>
  );
};
